var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"BLM-info"},[_c('div',[_vm._v(_vm._s(_vm.label)+":")]),_vm._v(" "),(_vm.value)?_c('div',[_vm._v(_vm._s(_vm.value))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }